import { useEffect, useRef, useState } from 'react';

export function useContainerHeight() {
  const containerRef = useRef<HTMLDivElement>(null);
  const [containerHeight, setContainerHeight] = useState(0);

  useEffect(() => {
    // Ensure the ref is assigned
    const element = containerRef.current;
    if (element == null) return;

    const updateHeight = () => {
      const nextHeight = Math.round(element.getBoundingClientRect().height);
      setContainerHeight(prev => (prev === nextHeight ? prev : nextHeight));
    };

    // Initial height calculation
    updateHeight();

    // Use ResizeObserver when available for accurate container size tracking
    const canObserve = typeof ResizeObserver !== 'undefined';
    const resizeObserver = canObserve ? new ResizeObserver(updateHeight) : null;
    resizeObserver?.observe(element);

    // Fallback to window resize
    window.addEventListener('resize', updateHeight);

    return () => {
      window.removeEventListener('resize', updateHeight);
      resizeObserver?.disconnect();
    };
  }, []);

  return { containerRef, containerHeight };
}
